import React from 'react';
import { Link } from 'react-router-dom';
import { TopNavigation } from '../Navigation/TopNavigation';
import landingStyles from '../LandingPage/LandingPage.module.scss'; // Reuse Landing Page styles for footer consistency
import styles from './StaticPageLayout.module.scss';
import { APP_YEAR } from '../../utils/constants';
import { tokens } from '../../styles/tokens';
import { CONTACT_EMAIL, CONTACT_MAILTO } from '../../utils/contactInfo';

const footerHeading = { fontSize: '14px', marginBottom: '8px', color: tokens.inkBlack } as const;
const footerCta = { color: tokens.softRed, fontWeight: 600 } as const;

interface LayoutProps {
  children: React.ReactNode;
  title?: string;
}

export const StaticPageLayout: React.FC<LayoutProps> = ({ children, title }) => {
  return (
    <div className={styles.layoutContainer}>
      <TopNavigation />

      <main style={{ flex: 1, padding: '40px 24px', maxWidth: '1000px', margin: '0 auto', width: '100%' }}>
        {title && <h1 style={{ fontSize: '3rem', marginBottom: '2rem', fontWeight: 700, fontFamily: 'Poppins, sans-serif' }}>{title}</h1>}
        {children}
      </main>

      <footer className={landingStyles.footer}>
        <div style={{ marginBottom: '24px', display: 'flex', flexWrap: 'wrap', justifyContent: 'center', gap: '24px' }}>
          <div>
            <h4 style={footerHeading}>Product</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link to="/download">Download</Link>
              <Link to="/pricing">Pricing</Link>
              <Link to="/science-of-time" style={footerCta}>Science of Time</Link>
            </div>
          </div>
          <div>
            <h4 style={footerHeading}>Company</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link to="/about">About Us</Link>
              <Link to="/careers">Careers</Link>
              <Link to="/blog">Blog</Link>
              <a href={CONTACT_MAILTO}>{CONTACT_EMAIL}</a>
            </div>
          </div>
          <div>
            <h4 style={footerHeading}>Legal</h4>
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
              <Link to="/legal/privacy">Privacy Policy</Link>
              <Link to="/legal/terms">Terms of Service</Link>
              <Link to="/legal/impressum">Impressum</Link>
              <Link to="/legal/cookies">Cookie Settings</Link>
            </div>
          </div>
        </div>
        <p>© {APP_YEAR} MyMinu. All rights reserved.</p>
      </footer>
    </div>
  );
};
